import './loader.css'

const Loader = () => {
  return (
    <div className="custom-spinner-wrapper">
      <div className="custom-spinner"></div>
    </div>
  );
};

export default Loader;
